import { render } from "./PlaylistComponent.vue?vue&type=template&id=254761a6&scoped=true"
import script from "./PlaylistComponent.vue?vue&type=script&lang=js"
export * from "./PlaylistComponent.vue?vue&type=script&lang=js"

import "./PlaylistComponent.vue?vue&type=style&index=0&id=254761a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254761a6"]])

export default __exports__